import AxiosInstance from "../Axios";

export function uploadFile(file: File[], projectId: string, location: string = "documents") {
    const formData = new FormData();
    // Check first if there is only one file
    if (file.length === 1) {
        formData.append("file", file[0]);
    } else {
        // If there are multiple files, append all of them
        file.forEach(f => formData.append("files", f));
    }
    formData.append("project_id", projectId);
    formData.append("location", location);

    return AxiosInstance.post("api/afs/upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}